<template>
    <Dialog
            :open="open"
            :title="$t('circles.createCircle')"
            @close="$emit('close')">
        <v-form ref="circleForm" v-model="valid" @submit.prevent="save">
            <v-row>
                <v-col cols="12">
                    <v-text-field
                            v-model="title"
                            :rules="[$validations.required]"
                            required>
                        <template v-slot:label>
                            {{ $t('circles.label') }}<sup>*</sup>
                        </template>
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="text-right">
                    <v-btn
                            :disabled="!valid"
                            :loading="loading"
                            class=" py-6 accentText--text shadow-inverse"
                            color="accent"
                            depressed
                            @click="save">
                        {{ $t('save') }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-form>
    </Dialog>
</template>

<script>
import Dialog from "@/components/reusable/Dialog/Dialog";

export default {
  name: "CircleAdd",
  components: {Dialog},
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    circleName: {
      type: String,
      required: false,
      default: ''
    },
    circleID: {
      type: Number,
      required: false,
      default: 0
    }
  },
  data() {
    return {
      loading: false,
      title: this.circleName,
      valid: false,
    };
  },
  watch: {
    circleName(val) {
      this.title = this.circleName;
      if (!val) {
        this.$refs.circleForm.reset();
      }
    }
  },
  methods: {
    save() {
      this.$refs.circleForm.validate();
      if (!this.valid || this.loading) {
        return;
      }
      let url = this.$store.getters.circles(this.$store.getters.getOrganizationId),
          method = 'POST';
      this.loading = true;
      if (this.circleID) {
        url = this.$store.getters.circle(this.circleID);
        method = 'PATCH';
      }
      this.axios(url, {
        method: method,
        data: this.title
      }).then(() => {
        if (this.circleID) {
          this.$store.dispatch('addNotification', {
            type: 'success',
            message: this.$t('success.circleUpdatedSuccessful'),
          });
        } else {
          this.$store.dispatch('addNotification', {
            type: 'success',
            message: this.$t('success.circleCreatedSuccessful'),
          });
        }
        this.title = '';
        this.$refs.circleForm.reset();
        this.$emit('close');
        this.$emit('refreshTable');
      }).finally(() => {
        this.loading = false;
      });
    }
  }
};
</script>

<style scoped>

</style>